import '../../../assets/login.css';

import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import InputAuth from '../../../components/UI/Input/InputAuth';
import { auth } from '../../../firebase-init';

const Login = () => {
  const { field, submitHandler, getUserPersonalInformation, errors, loading, setErrors } = useForm();
  const { t, i18n } = useTranslation();

  auth.onIdTokenChanged(async function (user) {
    if (user) {
      const userClaims = await user.getIdTokenResult();
      if (userClaims.claims.role && userClaims.claims.role === 'STUDENT') {
        await auth.signOut();
        setErrors(t('login.errors.user-not-found'));
      } else {
        await user.reload();
        await getUserPersonalInformation(user.uid);
      }
    }
  });
  return (
    <div className="col-lg-12 col-sm-12 login-banner">
      <div className="row d-flex justify-content-center ">
        <div className="col-lg-5  col-10 registration-card">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="login-card-title ">{t('login.connecter-vous-pour-continue')}</h2>
              </div>
              <div className="col-12">
                <form>
                  <div className="form-group login-form-input">
                    <label htmlFor="email" className="font-weight-bold">
                      {t('login.label.email')}
                    </label>
                    <InputAuth type="email" placeholder={t('login.placeholder.email')} {...field('email')} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="password" className="font-weight-bold">
                      {t('login.label.password')}
                    </label>
                    <InputAuth type="password" placeholder={t('login.placeholder.password')} {...field('password')} />
                  </div>
                  <div className="form-group form-check ">
                    <div className="row ">
                      <div className="col-12 text-right">
                        <Link to="/password-recovery">{t('login.label.forgot-password')}</Link>
                      </div>
                    </div>
                  </div>

                  <button
                    className="btn btn-warning  btn-block btn-lg font-weight-bold d-flex justify-content-center "
                    type="submit"
                    disabled={loading}
                    onClick={submitHandler}
                    style={{ fontSize: '20px' }}
                  >
                    <span
                      className="spinner-border "
                      role="status"
                      aria-hidden="true"
                      style={{ display: loading === true ? 'block' : 'none' }}
                    ></span>
                    <span className=""> {t('login.label.login')}</span>
                  </button>

                  <div className="text-start text-danger">
                    <span>{errors}</span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
